import Vue from 'vue'
import Router from 'vue-router'

// en
import EnIndex from '@/components/en/index'
import EnHome from '@/components/en/home'
import EnProduct from '@/components/en/product'
import EnStory from '@/components/en/story'
import EnNews from '@/components/en/news'
import EnNewsDetail from '@/components/en/newsdetail'
import EnVideo from '@/components/en/video'
import EnContactus from '@/components/en/contactus'

//  dealer
import Dealer from '@/components/en/dealer'

// cn
import Index from '@/components/cn/index'
import Home from '@/components/cn/home'
import Product from '@/components/cn/product'
import Story from '@/components/cn/story'
import Video from '@/components/cn/video'
import Contactus from '@/components/cn/contactus'
import R1config from '@/components/R1config/config'
import News from '@/components/cn/news'
import NewsDetail from '@/components/cn/newsdetail'

// tw
import TwIndex from '@/components/tw/index'
import TwHome from '@/components/tw/home'
import TwProduct from '@/components/tw/product'
import TwStory from '@/components/tw/story'
import TwVideo from '@/components/tw/video'
import TwContactus from '@/components/tw/contactus'
// import News from '@/components/tw/news'
// import NewsDetail from '@/components/tw/newsdetail'

// sk
import SkIndex from '@/components/sk/index'
import SkProduct from '@/components/sk/product'
import SkStory from '@/components/sk/story'
import SkVideo from '@/components/sk/video'
import SkContactus from '@/components/sk/contactus'

Vue.use(Router)

var router = {
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      redirect() {
        let lan = navigator.language || navigator.browserLanguage
        if (lan.indexOf('zh-CN') > -1 || lan.indexOf('zh-cn') > -1) {
          return '/cn'
        } else if (lan.indexOf('zh-TW') > -1) {
          return '/tc'
        } else if (lan.indexOf('ko') > -1) {
          return '/kr'
        } else {
          return '/en'
        }
      }
    },
    {
      path: '/ch',
      redirect: '/cn'
    },
    {
      path: '/pdfView',
      component: () => import('../components/support/pdfView.vue')
    },
    {
      path: '/cn',
      component: Index,
      children: [
        {
          path: '',
          component: Home,
          meta: {
            title: '蓝鲨智能电动摩托车官方网站',
            content: {
              keywords: '蓝鲨, 官网, 电动车, 摩托车, Robor, 新闻, 鲨湾科技',
              description: '蓝鲨，运用汽车科技创造的智能电动摩托车。'
            }
          }
        },
        {
          path: 'robor',
          component: Product,
          meta: {
            title: '蓝鲨 R 系列 - 运用汽车科技创造的智能电动摩托车',
            content: {
              keywords:
                '蓝鲨, 电动车, 摩托车, 官网, Robor, 动力, 电池, 续航, 参数, ArkRide OS',
              description:
                '蓝鲨智能电动摩托车 Robor，是一台运用汽车科技创造的智能电动摩托车。了解蓝鲨 Robor 参数配置、动力、电池、续航、智能功能、系统，尽在蓝鲨官网。'
            }
          }
        },
        {
          path: 'h1',
          component: () => import('../components/h1/index')
        },
        {
          path: 'story',
          component: Story,
          meta: {
            title: '鲨湾科技 - 用汽车科技重塑电动两轮车行业',
            content: {
              keywords: '蓝鲨, 电动车, 摩托车, 智能, 鲨湾, 产品, 服务',
              description:
                '蓝鲨智能电动摩托车是鲨湾科技旗下品牌。鲨湾科技是一家专注于打造智能电动出行产品及服务的国际化科技公司，致力于用汽车科技重塑电动两轮车行业，希望让智能电动摩托车风靡全球。'
            }
          }
        },
        {
          path: 'video',
          component: Video,
          meta: {
            title: '蓝鲨视频 - 欣赏蓝鲨 Robor 创新设计',
            content: {
              keywords: '蓝鲨, 摩托车, 汽车, 智能, 两轮',
              description:
                '蓝鲨智能电动摩托车 Robor，成熟应用汽车科技，为消费者带来智能驾驶体验。'
            }
          }
        },
        {
          path: 'contactus',
          component: Contactus,
          meta: {
            title: '联系我们 - 市场合作 商务合作 媒体合作 人才招聘',
            content: {
              keywords: '蓝鲨, 鲨湾科技, 合作, 联系方式',
              description:
                '蓝鲨智能电动摩托车是鲨湾科技旗下品牌。鲨湾科技是一家专注于打造智能电动出行产品及服务的国际化科技公司，致力于用汽车科技重塑电动两轮车行业，希望让智能电动摩托车风靡全球，欢迎合作联系。'
            }
          }
        },
        {
          path: 'support',
          component: () => import('../components/support/index.vue'),
          meta: {
            title: '服务支持',
            content: {
              keywords: '蓝鲨, 鲨湾科技, 合作, 联系方式',
              description:
                '蓝鲨智能电动摩托车是鲨湾科技旗下品牌。鲨湾科技是一家专注于打造智能电动出行产品及服务的国际化科技公司，致力于用汽车科技重塑电动两轮车行业，希望让智能电动摩托车风靡全球，欢迎合作联系。'
            }
          }
        },
        {
          path: 'productUserManual',
          component: () => import('../components/support/product.vue')
        },
        {
          path: 'app',
          component: () => import('../components/app/index.vue'),
          meta: {
            title: 'App下载',
            content: {
              keywords: '蓝鲨, 鲨湾科技, 合作, 联系方式',
              description:
                '蓝鲨智能电动摩托车是鲨湾科技旗下品牌。鲨湾科技是一家专注于打造智能电动出行产品及服务的国际化科技公司，致力于用汽车科技重塑电动两轮车行业，希望让智能电动摩托车风靡全球，欢迎合作联系。'
            }
          }
        },
        {
          path: 'R1config',
          component: R1config
        },
        {
          path: 'news',
          component: News,
          meta: {
            title: '蓝鲨新闻 - 了解蓝鲨最新资讯',
            content: {
              keywords:
                '蓝鲨, 电动车, 摩托车, 智能, 新闻, 电池, 动力, 安全, ArkRide OS',
              description:
                '鲨湾科技在2019年7月3日发布蓝鲨品牌及蓝鲨 R 系列智能电动摩托车产品，于9月20日亮相中国国际摩托车博览会，并邀请消费者进行了现场试驾。了解蓝鲨资讯，尽在蓝鲨官网。'
            }
          }
        },
        {
          path: 'newsdetail/:id',
          component: NewsDetail,
          meta: {
            content: {
              keywords:
                '蓝鲨, 电动车, 摩托车, 智能, 新闻, 电池, 动力, 安全, ArkRide OS',
              description:
                '鲨湾科技在2019年7月3日发布蓝鲨品牌及蓝鲨 R 系列智能电动摩托车产品，于9月20日亮相中国国际摩托车博览会，并邀请消费者进行了现场试驾。了解蓝鲨资讯，尽在蓝鲨官网。'
            }
          }
        }
      ]
    },
    {
      path: '/en',
      component: EnIndex,
      children: [
        {
          path: '',
          component: EnHome,
          meta: {
            title: 'Blueshark R1 Smart Electric Motorcycle Official Website',
            content: {
              keywords:
                'Blueshark, official, electric, motorcycle, news, Sharkgulf',
              description:
                'Blueshark R1, the smart electric motorcycle created with automotive technology.'
            }
          }
        },
        {
          path: 'robor',
          component: EnProduct,
          meta: {
            title: 'Blueshark R1 Smart Electric Motorcycle',
            content: {
              keywords:
                'Blueshark, scooter, motorcycle, official website, R1, power, battery, smart, safety',
              description:
                "Blueshark R1 - the smart electric motorcycle created with automotive technology. To learn more about the Blueshark R1's specifications, dynamic system, battery packs, range, smart features and ArkRide OS, please visit this official website of Blueshark."
            }
          }
        },
        {
          path: 'h1',
          component: () => import('../components/h1/index')
        },
        {
          path: 'story',
          component: EnStory,
          meta: {
            title: 'Sharkgulf Technology',
            content: {
              keywords:
                'Blueshark,  electric,  motorcycle,  smart,  Sharkgulf,  product, service',
              description:
                'Blueshark is a smart motocycle is created by Sharkgulf technology. Sharkgulf Tech is an international technology company that creates products and services of smart electric mobility.'
            }
          }
        },
        {
          path: 'news',
          component: EnNews,
          meta: {
            title: 'Blueshark News',
            content: {
              keywords:
                'Blueshark, electric, motocycle, smart, news, motor, controller, battery, safety, ADAS, ArkRide OS',
              description: 'Latest news on Blueshark smart electric motocycles.'
            }
          }
        },
        {
          path: 'newsdetail/:id',
          component: EnNewsDetail,
          meta: {
            content: {
              keywords:
                'Blueshark, electric, motocycle, smart, news, motor, controller, battery, safety, ADAS, ArkRide OS',
              description: 'Latest news on Blueshark smart electric motocycles.'
            }
          }
        },
        {
          path: 'video',
          component: EnVideo,
          meta: {
            title: 'Blueshark Videos',
            content: {
              keywords: 'Blueshark, electric, motorcycle, technology, smart',
              description: 'Blueshark smart electric motorcycle R1.'
            }
          }
        },
        {
          path: 'contactus',
          component: EnContactus,
          meta: {
            title: 'Contact us',
            content: {
              keywords:
                'Blueshark, Sharkgulf, collaborate, contact information',
              description:
                'Blueshark is a smart motocycle is created by Sharkgulf technology. Sharkgulf Tech is an international technology company that creates products and services of smart electric mobility.'
            }
          }
        },
        {
          path: 'R1config',
          component: R1config
        },
        {
          path: 'support',
          component: () => import('../components/support/index.vue'),
          meta: {
            title: 'Support',
            content: {
              keywords:
                'Blueshark, Sharkgulf, collaborate, contact information',
              description:
                'Blueshark is a smart motocycle is created by Sharkgulf technology. Sharkgulf Tech is an international technology company that creates products and services of smart electric mobility.'
            }
          }
        },
        {
          path: 'productUserManual',
          component: () => import('../components/support/product.vue')
        },
        {
          path: 'app',
          component: () => import('../components/app/index.vue'),
          meta: {
            title: 'app',
            content: {
              keywords:
                'Blueshark, Sharkgulf, collaborate, contact information',
              description:
                'Blueshark is a smart motocycle is created by Sharkgulf technology. Sharkgulf Tech is an international technology company that creates products and services of smart electric mobility.'
            }
          }
        }
      ]
    },
    {
      path: '/tc',
      component: TwIndex,
      children: [
        {
          path: '',
          component: TwHome,
          meta: {
            title: 'Blueshark 智慧機車',
            content: {
              keywords: 'Blueshark, 官網, 電動車, 機車, R 系列, 新聞, 鯊灣科技',
              description: 'Blueshark，運用汽車科技創造的智慧型電動機車。'
            }
          }
        },
        {
          path: 'robor',
          component: TwProduct,
          meta: {
            title: 'Blueshark 智慧機車',
            content: {
              keywords:
                'Blueshark, 電動車, 機車, 官網, R Series, 動力, 電池, 續航, 參數, ArkRide OS',
              description:
                'Blueshark智慧電動機車 R Series，是一台運用汽車科技創造的智慧電動機車。了解Blueshark R Series參數配置、動力、電池、續航、智慧功能、系統，盡在Blueshark官網。'
            }
          }
        },
        {
          path: 'h1',
          component: () => import('../components/h1/index')
        },
        {
          path: 'story',
          component: TwStory,
          meta: {
            title: 'Sharkgulf Technology',
            content: {
              keywords:
                'Blueshark,  electric,  motorcycle,  smart,  Sharkgulf,  product, service',
              description:
                'Blueshark is a smart motocycle is created by Sharkgulf technology. Sharkgulf Tech is an international technology company that creates products and services of smart electric mobility.'
            }
          }
        },
        {
          path: 'video',
          component: TwVideo,
          meta: {
            title: 'Blueshark影片 – 欣賞BluesharkR系列創新設計',
            content: {
              keywords: 'Blueshark, 機車, 汽車, 智慧, 兩輪',
              description:
                'Blueshark R 系列智慧電動機車，應用成熟智慧化汽車級科技，帶來兩輪騎乘新體驗。'
            }
          }
        },
        {
          path: 'contactus',
          component: TwContactus,
          meta: {
            title: 'Contact us',
            content: {
              keywords: 'Blueshark, 機車, 汽車, 智慧, 兩輪',
              description:
                'Blueshark R 系列智慧電動機車，應用成熟智慧化汽車級科技，帶來兩輪騎乘新體驗。'
            }
          }
        },
        {
          path: 'support',
          component: () => import('../components/support/index.vue'),
          meta: {
            title: 'Support',
            content: {
              keywords: 'Blueshark, 機車, 汽車, 智慧, 兩輪',
              description:
                'Blueshark R 系列智慧電動機車，應用成熟智慧化汽車級科技，帶來兩輪騎乘新體驗。'
            }
          }
        },
        {
          path: 'productUserManual',
          component: () => import('../components/support/product.vue')
        },
        {
          path: 'app',
          component: () => import('../components/app/index.vue'),
          meta: {
            title: 'app',
            content: {
              keywords: 'Blueshark, 機車, 汽車, 智慧, 兩輪',
              description:
                'Blueshark R 系列智慧電動機車，應用成熟智慧化汽車級科技，帶來兩輪騎乘新體驗。'
            }
          }
        }
      ]
    },
    {
      path: '/kr',
      name: 'index',
      component: SkIndex,
      children: [
        {
          path: '',
          component: SkProduct
          // meta: {
          //   title: '蓝鲨智能电动摩托车官方网站',
          //   content:{
          //     keywords:'蓝鲨, 官网, 电动车, 摩托车, Robor, 新闻, 鲨湾科技',
          //     description:'蓝鲨，运用汽车科技创造的智能电动摩托车。',
          //   }
          // }
        },
        {
          path: 'h1',
          component: () => import('../components/h1/index')
        },
        {
          path: 'story',
          component: SkStory
        },
        {
          path: 'video',
          component: SkVideo
        },
        {
          path: 'contactus',
          component: SkContactus
        },
        {
          path: 'support',
          component: () => import('../components/support/index.vue')
        },
        {
          path: 'productUserManual',
          component: () => import('../components/support/product.vue')
        },
        {
          path: 'app',
          component: () => import('../components/app/index.vue')
        }
      ]
    },
    {
      path: '/dealer',
      name: 'dealer',
      component: Dealer
    }
  ]
}

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router(router)



// WEBPACK FOOTER //
// ./src/router/index.js